<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="$l('dialog_title_chooseImage') || '选择已有图片'"
      width="825px"
      visible
      show-close
      :close-on-click-modal="false"
      :before-close="() => close()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :fabricCode="fabricCode"
        @close="close"
        @check="(e) => $emit('check', e)"
      />
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    fabricCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
